import {
  LegalEntityApplicationScope,
  TaxEnvironments,
  TaxIdentifierEnum,
  TaxProviderTypeEnum,
  TaxStatusEnum,
} from '@monetize/types/app';
import {
  AnrokLogo,
  AvalaraLogo,
  TaxwireLogo,
  VertexLogo,
} from '../assets/images';
import { objectToSelectOptions } from '../utils/misc';

export const TAX_IDENTIFIER_DISPLAY: {
  [key in TaxIdentifierEnum]: string;
} = {
  PRODUCT_ID: 'Product ID',
  TAX_ITEM_CODE: 'Tax Item Code',
  CUSTOM_ID: 'Custom ID',
  SKU: 'SKUs',
};

export const TAX_LEGAL_ENTITY_SCOPE_OPTIONS = [
  {
    title: 'All Legal Entities',
    value: LegalEntityApplicationScope.ALL,
  },
  {
    title: 'Specific Legal Entities',
    value: LegalEntityApplicationScope.SCOPED,
  },
];

export const TAX_LEGAL_ENTITY_SCOPE_DISPLAY: {
  [key in LegalEntityApplicationScope]: string;
} = {
  ALL: 'All Legal Entities',
  SCOPED: 'Specific Legal Entities',
};

export const TAX_IDENTIFIER_SELECT_OPTIONS = objectToSelectOptions(
  TAX_IDENTIFIER_DISPLAY,
);

export const TAX_PROVIDER_DISPLAY: {
  [key in TaxProviderTypeEnum]: {
    name: string;
    icon: any;
  };
} = {
  ANROK: {
    name: 'Anrok',
    icon: AnrokLogo,
  },
  AVALARA: {
    name: 'Avalara',
    icon: AvalaraLogo,
  },
  TAXWIRE: {
    name: 'Taxwire',
    icon: TaxwireLogo,
  },
  VERTEX: {
    name: 'Vertex',
    icon: VertexLogo,
  },
};

export const TAX_STATUS_DISPLAY: {
  [key in TaxStatusEnum]: string;
} = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};

export const TAX_ENVIRONMENTS_DISPLAY: {
  [key in TaxEnvironments]: string;
} = {
  PRODUCTION: 'Production',
  SANDBOX: 'Sandbox',
};

export const TAX_ENVIRONMENTS_SELECT_OPTIONS = objectToSelectOptions(
  TAX_ENVIRONMENTS_DISPLAY,
);

export const TAX_ENTITY_USE_CODES = [
  { title: 'Agriculture', value: 'H' },
  { title: 'Charitable/Exempt Org', value: 'E' },
  { title: 'Commercial Aquaculture', value: 'P' },
  { title: 'Commercial Fishery', value: 'Q' },
  { title: 'Direct Mail', value: 'K' },
  { title: 'Direct Pay', value: 'J' },
  { title: 'Educational Org', value: 'M' },
  { title: 'Federal Gov', value: 'A' },
  { title: 'Foreign Diplomat', value: 'D' },
  { title: 'Industrial Prod/Manufacturers', value: 'I' },
  { title: 'Local Government', value: 'N' },
  { title: 'Non-Exempt Taxable Customer', value: 'TAXABLE' },
  { title: 'Non-Resident', value: 'R' },
  { title: 'Other/Custom', value: 'L' },
  { title: 'Religious Org', value: 'F' },
  { title: 'Resale', value: 'G' },
  { title: 'State Gov', value: 'B' },
  { title: 'Tribal Government', value: 'C' },
];

export const VERTEX_CREDENTIAL_TYPES = [
  { title: 'O Series Cloud Credentials', value: 'OSeriesCloudCredentials' },
  { title: 'On Demand Credentials', value: 'OnDemandCredentials' },
];

export const VERTEX_IDENTITY_PROVIDERS = [
  { title: 'VERX', value: 'VERX' },
  { title: 'Legacy', value: 'LEGACY' },
];
